import e, { OPTIONS as L } from "../../managers/braze-instance.js";
import ControlMessage from "../models/control-message.js";
import HtmlMessage from "../models/html-message.js";
import InAppMessage from "../models/in-app-message.js";
import SlideUpMessage from "../models/slide-up-message.js";
import se from "../in-app-message-manager-factory.js";
import me from "../display/get-animation-effect.js";
import ce from "../display/in-app-message-to-html.js";
import { logInAppMessageImpression } from "../log-in-app-message-impression.js";
import {
  ORIENTATION as fe,
  WindowUtils as Y,
} from "../../util/window-utils.js";
import { isURIJavascriptOrData as N } from "../../util/url-utils.js";
import { KeyCodes as at } from "../../util/key-codes.js";
import { setupInAppMessageUI as ss } from "../../ui/js/index.js";
import r from "../../../shared-lib/braze-shared-lib.js";
import { toRgba as ie } from "../../util/color-utils.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as P } from "../../common/constants.js";
import { isIFrame as It } from "../utils/in-app-message-utils.js";
export function showInAppMessage(s, t, o) {
  if (!e.rr()) return;
  if ((ss(), null == s)) return !1;
  if (s instanceof ControlMessage)
    return (
      r.j.info(
        "User received control for a multivariate test, logging to Braze servers.",
      ),
      logInAppMessageImpression(s),
      !0
    );
  if (!(s instanceof InAppMessage)) return !1;
  if (s.constructor === InAppMessage) return !1;
  const i = se.m();
  s.Nh();
  const n = s instanceof HtmlMessage;
  if (n && !s.trusted && !e.nr())
    return (
      r.j.error(
        'HTML in-app messages are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these messages.',
      ),
      i.Ji(s.triggerId, InAppMessage.Ie.Ch),
      !1
    );
  if ((null == t && (t = document.body), s.xe())) {
    if (t.querySelectorAll(".ab-modal-interactions").length > 0)
      return (
        r.j.info(
          `Cannot show in-app message ${s.message} because another message is being shown.`,
        ),
        i.Ji(s.triggerId, InAppMessage.Ie.Le),
        !1
      );
  }
  if (Y.ao()) {
    const e = Y.mo();
    if (
      (e === fe.PORTRAIT &&
        s.orientation === InAppMessage.Orientation.LANDSCAPE) ||
      (e === fe.LANDSCAPE &&
        s.orientation === InAppMessage.Orientation.PORTRAIT)
    ) {
      const t = e === fe.PORTRAIT ? "portrait" : "landscape",
        o =
          s.orientation === InAppMessage.Orientation.PORTRAIT
            ? "portrait"
            : "landscape";
      return (
        r.j.info(
          `Not showing ${o} in-app message ${s.message} because the screen is currently ${t}`,
        ),
        i.Ji(s.triggerId, InAppMessage.Ie.dh),
        !1
      );
    }
  }
  if (!e.nr()) {
    let e = !1;
    if (s.buttons && s.buttons.length > 0) {
      const t = s.buttons;
      for (let s = 0; s < t.length; s++)
        if (t[s].clickAction === InAppMessage.ClickAction.URI) {
          const o = t[s].uri;
          e = N(o);
        }
    } else s.clickAction === InAppMessage.ClickAction.URI && (e = N(s.uri));
    if (e)
      return (
        r.j.error(
          'Javascript click actions are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable these actions.',
        ),
        i.Ji(s.triggerId, InAppMessage.Ie.Ch),
        !1
      );
  }
  const a = document.createElement("div");
  if (
    ((a.className = "ab-iam-root v3"),
    (a.className += me(s)),
    a.setAttribute("role", "complementary"),
    s.Ne() && (a.id = s.htmlId),
    e.nn(L.lo) && (a.style.zIndex = (e.nn(L.lo) + 1).toString()),
    t.appendChild(a),
    s.Ae())
  ) {
    const t = document.createElement("style");
    (t.innerHTML = s.css),
      (t.id = s.Ce()),
      null != e.nn(L.po) && t.setAttribute("nonce", e.nn(L.po)),
      document.getElementsByTagName("head")[0].appendChild(t);
  }
  const m = s instanceof SlideUpMessage,
    l = ce(
      s,
      () => {
        import("../../Feed/ui/show-feed.js").then((s) => {
          e.fe() ? s.showFeed() : r.j.error(P);
        });
      },
      (t) => {
        if (s.xe() && s.io()) {
          const o = document.createElement("div");
          if (
            ((o.className = "ab-page-blocker"),
            s.Ae() || (o.style.backgroundColor = ie(s.frameColor)),
            e.nn(L.lo) && (o.style.zIndex = e.nn(L.lo).toString()),
            a.appendChild(o),
            !e.nn(L.mh))
          ) {
            const e = new Date().valueOf();
            o.onclick = (o) => {
              new Date().valueOf() - e > InAppMessage.Ph &&
                (s.ye(t), o.stopPropagation());
            };
          }
          a.appendChild(t), t.focus(), s.Ah(a);
        } else if (m) {
          const e = document.querySelectorAll(".ab-slideup");
          let o = null;
          for (let s = e.length - 1; s >= 0; s--)
            if (e[s] !== t) {
              o = e[s];
              break;
            }
          if (s.slideFrom === InAppMessage.SlideFrom.TOP) {
            let e = 0;
            null != o && (e = o.offsetTop + o.offsetHeight),
              (t.style.top = Math.max(e, 0) + "px");
          } else {
            let e = 0;
            null != o &&
              (e =
                (window.innerHeight || document.documentElement.clientHeight) -
                o.offsetTop),
              (t.style.bottom = Math.max(e, 0) + "px");
          }
        } else if (n && !e.nn(L.mh)) {
          const e = s;
          It(t) &&
            t.contentWindow &&
            t.contentWindow.addEventListener("keydown", function (s) {
              s.keyCode === at._h && e.closeMessage();
            });
        }
        logInAppMessageImpression(s),
          s.dismissType === InAppMessage.DismissType.AUTO_DISMISS &&
            setTimeout(() => {
              a.contains(t) && s.ye(t);
            }, s.duration),
          "function" == typeof o && o();
      },
      (e, t) => {
        r.j.info(e), i.Ji(s.triggerId, t);
      },
      e.nn(L.fo),
      e.nn(L.lo),
      e.nn(L.po),
      t,
    );
  return (n || m) && (a.appendChild(l), s.Ah(a)), !0;
}
